import Gastos from "./Gastos";
export default Gastos;